import React from 'react'
import classnames from 'classnames'
import { BreadcrumbItem } from './BreadCrumbItem'

interface BreadcrumbsProps {
  displayName: string[] | undefined
  path: string | undefined
  noHover?: boolean
  showHome?: boolean
  className?: string
  collapseMobile?: boolean
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  let {
    path,
    noHover = false,
    displayName,
    showHome = true,
    className = '',
    collapseMobile = false
  } = props

  if (typeof path === 'undefined' || typeof displayName === 'undefined') {
    return null
  }

  const styles = {
    list: classnames(
      `d-flex align-items-center justify-content-start breadcrumb bg-transparent p-0 ${className}`,
      { 'collapse-mobile': collapseMobile }
    )
  }
  let slugs = path.split('/').filter(Boolean).filter(val => val !== 'de')
  let breadCrumbs = displayName.map((name: string, index: number) => {

    let href = '/' + slugs.slice(0, index + 1).join('/')
    let hasSlug = typeof slugs[index] !== 'undefined'
    let isLast = index + 1 === slugs.length

    return (
      <BreadcrumbItem
        key={`breadcrumb-item-${index}`}
        active={!hasSlug || isLast}
        href={href}
        noHover={noHover}
        collapseMobile={collapseMobile}
      >
        {name}
      </BreadcrumbItem>
    )
  })

  return (
    <nav aria-label='breadcrumb'>
      <ol
        className={styles.list}
      >
        {
          showHome && (
            <BreadcrumbItem
              active={false}
              href={'/'}
              noHover={noHover}
            >
              Docs
            </BreadcrumbItem>
          )
        }
        {breadCrumbs}
      </ol>
    </nav>
  )
}
